export const productCategories = [
  {
    id: 'classic',
    name: '經典系列',
    description: '經典配方，溫和滋養，適合日常長期使用，幫助穩步提升活力與自信。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20premium%20wellness%20supplement%20bottle%20on%20soft%20cream%20background%20with%20warm%20golden%20accents%2C%20minimalist%20product%20photography%2C%20natural%20lighting%2C%20clean%20composition%2C%20luxurious%20feel%2C%20soft%20shadows%2C%20editorial%20style&width=800&height=600&seq=xfb-cat-classic&orientation=landscape',
    products: [
      { id: 'classic-1', name: '性福寶經典版', price: 298, originalPrice: 398, description: '基礎活力配方，溫和滋養，適合初次嘗試者。', badge: '入門推薦', stock: 120 },
      { id: 'classic-2', name: '性福寶經典加強版', price: 398, originalPrice: 528, description: '加倍濃縮配方，更強效的活力支持。', badge: '熱銷單品', stock: 85 },
      { id: 'classic-3', name: '性福寶經典套裝', price: 698, originalPrice: 996, description: '三瓶組合，長期調理，效果更持久穩定。', badge: '超值組合', stock: 60 },
    ],
  },
  {
    id: 'premium',
    name: '尊享系列',
    description: '高端配方，精選稀有成分，專為追求卓越體驗的您打造。',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20premium%20wellness%20supplement%20in%20golden%20bottle%20on%20marble%20surface%20with%20warm%20ambient%20lighting%2C%20high-end%20product%20photography%2C%20elegant%20composition%2C%20soft%20golden%20tones&width=800&height=600&seq=xfb-cat-premium&orientation=landscape',
    products: [
      { id: 'premium-1', name: '性福寶尊享版', price: 598, originalPrice: 798, description: '高端精華配方，含珍稀人參萃取，全面提升活力。', badge: '尊享之選', stock: 45 },
      { id: 'premium-2', name: '性福寶尊享鉑金版', price: 998, originalPrice: 1298, description: '頂級配方，多重草本精華協同增效。', badge: '限量發售', stock: 20 },
    ],
  },
  {
    id: 'couple',
    name: '伴侶系列',
    description: '專為伴侶設計，雙人共享幸福時刻，增進親密關係。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20wellness%20supplement%20bottles%20side%20by%20side%20on%20soft%20linen%20fabric%20with%20warm%20candlelight%20ambiance%2C%20romantic%20yet%20tasteful%20product%20photography&width=800&height=600&seq=xfb-cat-couple&orientation=landscape',
    products: [
      { id: 'couple-1', name: '性福寶伴侶套裝', price: 888, originalPrice: 1196, description: '雙人份量，男女皆宜，共同享受美好時光。', badge: '伴侶推薦', stock: 50 },
      { id: 'couple-2', name: '性福寶蜜月禮盒', price: 1288, originalPrice: 1698, description: '精緻禮盒包裝，含經典與尊享各一瓶，送禮首選。', badge: '送禮佳品', stock: 30 },
    ],
  },
  {
    id: 'daily',
    name: '日常養護系列',
    description: '日常保健配方，溫和持久，適合長期養護使用。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20wellness%20supplement%20bottle%20with%20green%20tea%20leaves%20and%20natural%20elements%20on%20light%20wooden%20surface%2C%20soft%20morning%20light%2C%20organic%20feel%2C%20lifestyle%20photography&width=800&height=600&seq=xfb-cat-daily&orientation=landscape',
    products: [
      { id: 'daily-1', name: '性福寶日常養護版', price: 198, originalPrice: 268, description: '輕量配方，日常保健，溫和調理不刺激。', badge: '日常必備', stock: 150 },
    ],
  },
];

export const allProducts = productCategories.flatMap(cat => cat.products);